/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_AsyncScripts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/AsyncScripts */ "./resources/scripts/components/AsyncScripts.ts");
/* harmony import */ var _scripts_components_StoreLocator_StoreLocator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/StoreLocator/StoreLocator */ "./resources/scripts/components/StoreLocator/StoreLocator.ts");
/* harmony import */ var _scripts_components_Quiz__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/Quiz */ "./resources/scripts/components/Quiz.ts");
/* harmony import */ var _scripts_components_InstagramFeed_InstagramFeed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/InstagramFeed/InstagramFeed */ "./resources/scripts/components/InstagramFeed/InstagramFeed.ts");
/* harmony import */ var _scripts_components_QuickAdd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/QuickAdd */ "./resources/scripts/components/QuickAdd.ts");
/* harmony import */ var _scripts_components_ConsentMode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./scripts/components/ConsentMode */ "./resources/scripts/components/ConsentMode.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");







var asyncScripts = new _scripts_components_AsyncScripts__WEBPACK_IMPORTED_MODULE_0__["default"]();
asyncScripts.init();
customElements.define('store-locator', _scripts_components_StoreLocator_StoreLocator__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('edition-quiz', _scripts_components_Quiz__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('edition-quickadd', _scripts_components_QuickAdd__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define('edition-instagram-feed', _scripts_components_InstagramFeed_InstagramFeed__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define('edition-geolocator', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_5__["default"]);
var consentMode = new _scripts_components_ConsentMode__WEBPACK_IMPORTED_MODULE_6__["default"]();
consentMode.init();
// The above are imports and definitions for the custom elements and components
// The below are small scripts that are used to add functionality to the site
// scroll event to change header background color
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.cc-header_bg');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }
});
// product page - read more button
document.addEventListener('DOMContentLoaded', function () {
  var readMoreBtn = document.getElementById('cc-read-more-btn');
  var descriptionAccordions = Array.from(document.querySelectorAll('.product-description-accordion'));
  if (readMoreBtn) {
    readMoreBtn.addEventListener('click', function () {
      descriptionAccordions.forEach(function (accordion) {
        var details = accordion.querySelector('details');
        var readMoreText = document.querySelector('#readmore-text');
        var readLessText = document.querySelector('#readless-text');
        if (!details.open) {
          readMoreText.classList.add('tw-hidden');
          readLessText.classList.remove('tw-hidden');
          details.classList.add('is-open');
          details.open = true;
          // Scroll to the accordion with a 100px offset
          var offset = 100;
          var elementPosition = accordion.getBoundingClientRect().top + window.scrollY;
          // Ensure the position is not negative or already at the top
          var offsetPosition = Math.max(elementPosition - offset, 0);
          if (offsetPosition > 0) {
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        } else {
          readMoreText.classList.remove('tw-hidden');
          readLessText.classList.add('tw-hidden');
          details.classList.remove('is-open');
          details.open = false;
        }
      });
    });
  }
});
// discount modal - product page
document.addEventListener('DOMContentLoaded', function () {
  var discountBtn = document.getElementById('discount_btn');
  var modalBackground = document.getElementById('modal_background');
  if (discountBtn && modalBackground) {
    discountBtn.addEventListener('click', function () {
      modalBackground.classList.toggle('tw-hidden');
    });
    modalBackground.addEventListener('click', function (event) {
      if (event.target === modalBackground) {
        modalBackground.classList.add('tw-hidden');
      }
    });
  }
});
// product page - Judge me reviews clone
document.addEventListener('DOMContentLoaded', function () {
  var sourceElement = document.getElementById('judgeme_product_reviews');
  var targetElements = document.querySelectorAll('.cc-reviews_container');
  if (sourceElement && targetElements.length > 0) {
    var clone = sourceElement.cloneNode(true);
    targetElements.forEach(function (targetElement) {
      targetElement.appendChild(clone.cloneNode(true));
    });
    sourceElement.style.display = 'none';
  }
});
// collection page - seo description with read more button
document.addEventListener('DOMContentLoaded', function () {
  var readMoreButton = document.getElementById('read-more');
  var readLessButton = document.getElementById('read-less');
  var seoText = document.getElementById('seo-text');
  if (readMoreButton && readLessButton && seoText) {
    var checkHeight = function checkHeight() {
      var maxHeight = 8 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      if (seoText.scrollHeight <= maxHeight) {
        // Content is not too big
        readMoreButton.style.display = 'none';
        readLessButton.style.display = 'none';
        seoText.classList.remove('fade-out');
        seoText.classList.remove('custom-seo-text');
      } else {
        // Content is too big
        readMoreButton.style.display = 'block';
        readLessButton.style.display = 'none';
        seoText.classList.add('custom-seo-text');
      }
    };
    checkHeight();
    readMoreButton.addEventListener('click', function () {
      seoText.classList.add('expanded');
      readMoreButton.style.display = 'none';
      readLessButton.style.display = 'block';
    });
    readLessButton.addEventListener('click', function () {
      seoText.classList.remove('expanded');
      readMoreButton.style.display = 'block';
      readLessButton.style.display = 'none';
    });
    window.addEventListener('resize', checkHeight);
  }
});
// product page - add to cart on mobile fixed view
document.addEventListener('DOMContentLoaded', function () {
  var fixedAddToCart = document.getElementById('fixed-add-to-cart');
  var originalAddToCart = document.querySelector('.product-form .button[type="submit"]');
  if (fixedAddToCart && originalAddToCart) {
    window.addEventListener('scroll', function () {
      var rect = originalAddToCart.getBoundingClientRect();
      var isVisible = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
      if (isVisible) {
        fixedAddToCart.classList.add('hidden');
      } else {
        fixedAddToCart.classList.remove('hidden');
      }
    });
    var fixedAddToCartBtn = document.getElementById('fixed-add-to-cart-btn');
    if (fixedAddToCartBtn) {
      fixedAddToCartBtn.addEventListener('click', function () {
        originalAddToCart.click();
      });
    }
  }
});
// collection page - video toggle play buttons
document.addEventListener('DOMContentLoaded', function () {
  var video = document.getElementById('backgroundVideo');
  var playButton = document.getElementById('playButton');
  var pauseButton = document.getElementById('pauseButton');
  var videoContainer = document.querySelector('.background-video-container');
  if (videoContainer) {
    playButton.addEventListener('click', function () {
      video.play();
      playButton.style.display = 'none';
      pauseButton.style.display = 'block';
    });
    pauseButton.addEventListener('click', function () {
      video.pause();
      playButton.style.display = 'block';
      pauseButton.style.display = 'none';
    });
    video.addEventListener('play', function () {
      playButton.style.display = 'none';
      pauseButton.style.display = 'block';
    });
    video.addEventListener('pause', function () {
      playButton.style.display = 'block';
      pauseButton.style.display = 'none';
    });
    videoContainer.addEventListener('mouseenter', function () {
      if (!video.paused) {
        playButton.style.display = 'none';
        pauseButton.style.display = 'block';
      }
    });
    videoContainer.addEventListener('mouseleave', function () {
      if (!video.paused) {
        playButton.style.display = 'none';
        pauseButton.style.display = 'none';
      }
    });
  }
});
// header search box
document.addEventListener('DOMContentLoaded', function () {
  var searchIconBtn = document.querySelector('.show-search-link');
  var header = document.querySelector('.pageheader');
  var searchCloseBtn = document.querySelector('#closebutton');
  if (searchIconBtn && header) {
    searchIconBtn.addEventListener('click', function () {
      header.classList.toggle('search-open');
    });
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        header.classList.remove('search-open');
      }
    });
  }
  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', function () {
      header.classList.remove('search-open');
    });
  }
});

/***/ }),

/***/ "./resources/scripts/components/AsyncScripts.ts":
/*!******************************************************!*\
  !*** ./resources/scripts/components/AsyncScripts.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AsyncScripts)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var AsyncScripts = /*#__PURE__*/function () {
  function AsyncScripts() {
    _classCallCheck(this, AsyncScripts);
    this.init = this.init.bind(this);
  }
  return _createClass(AsyncScripts, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var scriptsHtml;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              localStorage.setItem('asyncscripts', 'true');
              _context.n = 1;
              return this.getAsyncScripts();
            case 1:
              scriptsHtml = _context.v;
              setTimeout(function () {
                _this.loadAsyncScripts(scriptsHtml);
              }, 3500);
              this.eventListeners(scriptsHtml);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "getAsyncScripts",
    value: function () {
      var _getAsyncScripts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, scriptsHtml, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return window.fetch("/?section_id=asyncheadscripts");
            case 1:
              response = _context2.v;
              if (!response.ok) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return response.text();
            case 2:
              scriptsHtml = _context2.v;
              return _context2.a(2, scriptsHtml);
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              throw new Error(_t);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 4]]);
      }));
      function getAsyncScripts() {
        return _getAsyncScripts.apply(this, arguments);
      }
      return getAsyncScripts;
    }()
  }, {
    key: "eventListeners",
    value: function eventListeners(scriptsHtml) {
      var _this2 = this;
      document.addEventListener('click', function () {
        _this2.loadAsyncScripts(scriptsHtml);
      });
      document.addEventListener('scroll', function () {
        _this2.loadAsyncScripts(scriptsHtml);
      });
      document.addEventListener('mousemove', function () {
        _this2.loadAsyncScripts(scriptsHtml);
      });
      document.addEventListener('keydown', function () {
        _this2.loadAsyncScripts(scriptsHtml);
      });
      document.addEventListener('touchstart', function () {
        _this2.loadAsyncScripts(scriptsHtml);
      });
    }
  }, {
    key: "loadAsyncScripts",
    value: function loadAsyncScripts(scriptsHtml) {
      var _this3 = this;
      if (localStorage.getItem('asyncscripts')) {
        console.log('Loading async scripts');
        var scriptsMarkup = document.createElement('div');
        scriptsMarkup.innerHTML = scriptsHtml;
        var scripts = Array.from(scriptsMarkup.querySelectorAll('script'));
        if (scripts.length > 0) {
          scripts.forEach(function (script) {
            var newScript = script;
            document.head.appendChild(newScript);
            if (newScript.getAttribute('src') === null) {
              _this3.executeInlineScript(newScript.innerHTML);
            }
          });
        }
        localStorage.removeItem('asyncscripts');
      }
    }
  }, {
    key: "executeInlineScript",
    value: function executeInlineScript(scriptContent) {
      try {
        var scriptFunction = new Function(scriptContent);
        scriptFunction();
      } catch (error) {
        console.error('Error executing inline script:', error);
      }
    }
  }]);
}();
/* eslint-disable */


/***/ }),

/***/ "./resources/scripts/components/ConsentMode.ts":
/*!*****************************************************!*\
  !*** ./resources/scripts/components/ConsentMode.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionConsent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EditionConsent = /*#__PURE__*/function () {
  function EditionConsent() {
    _classCallCheck(this, EditionConsent);
    // declare dataLayer
    _defineProperty(this, "dataLayer", window.dataLayer || []);
    this.init = this.init.bind(this);
    this.updateConsent = this.updateConsent.bind(this);
    this.consentSettings = this.consentSettings.bind(this);
    this.gtag = this.gtag.bind(this);
  }
  /* eslint-disable prefer-rest-params */
  return _createClass(EditionConsent, [{
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      this.dataLayer.push(arguments);
    }
    /* eslint-disable prefer-rest-params */
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      document.addEventListener('visitorConsentCollected', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, visitorConsent;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = 'update';
              _context.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context.v;
              _this.consentSettings(visitorConsent, state);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })));
    }
  }, {
    key: "updateConsent",
    value: function updateConsent() {
      var state = 'update';
      if (window.Shopify.customerPrivacy === undefined) return;
      var visitorConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
      this.consentSettings(visitorConsent, state);
    }
  }, {
    key: "consentSettings",
    value: function consentSettings(visitorConsent, state) {
      var consent = {
        functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
        analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
        personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
        ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
        ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
        ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
        wait_for_update: 500
      };
      this.gtag('consent', state, consent);
      localStorage.setItem('consentSettings', JSON.stringify(consent));
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* fire custom events
geolocator:toggle - Use this event to toggle the modal
document.dispatchEvent(new ('geolocator:toggle', { detail: { message: 'toggle modal' } }));


geolocator:getLocation - Use this event to get the location of the visitor
document.dispatchEvent(new CustomEvent('geolocator:getLocation', { detail: { message: 'get location' } }));
*/
var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "activeCountryHandle", _this.dataset.activecountryhandle);
    _defineProperty(_this, "cookieDuration", _this.dataset.cookieduration);
    _defineProperty(_this, "modal", document.getElementById('cc_localization_modal'));
    _defineProperty(_this, "getLocationEndpoint", '/browsing_context_suggestions.json');
    _defineProperty(_this, "cookiename", 'editiongeolocation=');
    _defineProperty(_this, "urlParam", '?edition-geoswtich');
    _this.toggleModal = _this.toggleModal.bind(_this);
    _this.getVistorLocation = _this.getVistorLocation.bind(_this);
    _this.setGeoCookie = _this.setGeoCookie.bind(_this);
    _this.getGeoCookie = _this.getGeoCookie.bind(_this);
    _this.handleCountryChange = _this.handleCountryChange.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var iconCross, geoCountryButtons, url, visitorLocation;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              setTimeout(function () {
                var toggleBtns = Array.from(document.querySelectorAll('.cc_localization_btn'));
                toggleBtns.forEach(function (btn) {
                  btn.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    _this2.toggleModal();
                  });
                });
              }, 1000);
              iconCross = document.getElementById('cc_icon_cross');
              if (iconCross) {
                iconCross.addEventListener('click', function (event) {
                  event.preventDefault();
                  event.stopPropagation();
                  event.stopImmediatePropagation();
                  _this2.toggleModal();
                });
              }
              geoCountryButtons = Array.from(this.querySelectorAll('.geo-country'));
              geoCountryButtons.forEach(function (btn) {
                btn.addEventListener('click', function (event) {
                  event.preventDefault();
                  event.stopPropagation();
                  event.stopImmediatePropagation();
                  _this2.setGeoCookie();
                  _this2.handleCountryChange(btn);
                });
              });
              url = window.location.href;
              if (url.includes('edition-geoswtich')) {
                this.setGeoCookie();
              }
              _context2.n = 1;
              return this.getVistorLocation();
            case 1:
              visitorLocation = _context2.v;
              if (visitorLocation !== this.activeCountryHandle && !this.getGeoCookie()) {
                this.toggleModal();
              }
              // Listen for custom events
              document.addEventListener('geolocator:toggle', this.toggleModal);
              document.addEventListener('geolocator:getLocation', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var _t, _t2;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _t = console;
                      _context.n = 1;
                      return _this2.getVistorLocation();
                    case 1:
                      _t2 = _context.v;
                      _t.log.call(_t, _t2);
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              })));
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "toggleModal",
    value: function toggleModal() {
      if (this.modal) {
        this.modal.classList.toggle('tw-hidden');
        document.body.classList.toggle(document.body.classList.contains('tw-overflow-hidden') ? 'tw-overflow-hidden' : 'tw-overflow-hidden');
      }
    }
  }, {
    key: "getVistorLocation",
    value: function () {
      var _getVistorLocation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var response, data, vistorCountryHandle, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return fetch(this.getLocationEndpoint);
            case 1:
              response = _context3.v;
              if (!response.ok) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return response.json();
            case 2:
              data = _context3.v;
              vistorCountryHandle = data.detected_values.country.handle;
              return _context3.a(2, vistorCountryHandle);
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              throw new Error(_t3);
            case 5:
              return _context3.a(2, '');
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function getVistorLocation() {
        return _getVistorLocation.apply(this, arguments);
      }
      return getVistorLocation;
    }()
  }, {
    key: "setGeoCookie",
    value: function setGeoCookie() {
      var date = new Date();
      date.setTime(date.getTime() + parseInt(this.cookieDuration, 10) * 24 * 60 * 60 * 1000);
      document.cookie = "editiongeolocation=countrychanged; expires=".concat(date.toUTCString(), "; path=/");
    }
  }, {
    key: "getGeoCookie",
    value: function getGeoCookie() {
      var name = this.cookiename;
      var decodedCookie = decodeURIComponent(document.cookie);
      var cookieArray = decodedCookie.split(';');
      var cookie = cookieArray.find(function (c) {
        return c.includes(name);
      });
      return cookie;
    }
  }, {
    key: "handleCountryChange",
    value: function handleCountryChange(btn) {
      var url = btn.getAttribute('href');
      var urlParam = this.urlParam;
      var newUrl = "".concat(url).concat(urlParam);
      window.location.href = newUrl;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/InstagramFeed/InstagramFeed.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/InstagramFeed/InstagramFeed.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionInstagramFeed)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EditionInstagramFeed = /*#__PURE__*/function (_HTMLElement) {
  function EditionInstagramFeed() {
    var _this;
    _classCallCheck(this, EditionInstagramFeed);
    _this = _callSuper(this, EditionInstagramFeed);
    _defineProperty(_this, "feedUrl", _this.dataset.feedurl);
    _this.initEmbedScript = _this.initEmbedScript.bind(_this);
    _this.initFeed = _this.initFeed.bind(_this);
    return _this;
  }
  _inherits(EditionInstagramFeed, _HTMLElement);
  return _createClass(EditionInstagramFeed, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initEmbedScript();
    }
  }, {
    key: "initEmbedScript",
    value: function () {
      var _initEmbedScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var instagramEmbedScript;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                instagramEmbedScript = document.createElement('script');
                instagramEmbedScript.src = 'https://www.instagram.com/embed.js';
                instagramEmbedScript.defer = true;
                document.body.appendChild(instagramEmbedScript);
                this.initFeed();
              } catch (error) {
                console.error(error);
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initEmbedScript() {
        return _initEmbedScript.apply(this, arguments);
      }
      return initEmbedScript;
    }()
  }, {
    key: "initFeed",
    value: function () {
      var _initFeed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var feedHolder, errorMsg, spinner;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                feedHolder = this.querySelector('blockquote');
                if (feedHolder && this.feedUrl !== '') {
                  feedHolder.dataset.instgrmPermalink = this.feedUrl;
                }
              } catch (error) {
                errorMsg = this.querySelector('#instagram-feed_error-message');
                errorMsg.textContent = error.message;
              } finally {
                spinner = this.querySelector('.instagram-feed_loading-spinner');
                spinner.setAttribute('aria-hidden', 'true');
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initFeed() {
        return _initFeed.apply(this, arguments);
      }
      return initFeed;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/QuickAdd.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/components/QuickAdd.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ QuickAdd)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QuickAdd = /*#__PURE__*/function (_HTMLElement) {
  function QuickAdd() {
    var _this;
    _classCallCheck(this, QuickAdd);
    _this = _callSuper(this, QuickAdd);
    _defineProperty(_this, "addProductUrl", '/cart/add.js');
    _this.handleAddToCart = _this.handleAddToCart.bind(_this);
    _this.addToCart = _this.addToCart.bind(_this);
    var quickAddBtn = _this.querySelector('.edition-quickadd-btn');
    quickAddBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.handleAddToCart();
    });
    return _this;
  }
  // Method to handle quickadd btn click
  _inherits(QuickAdd, _HTMLElement);
  return _createClass(QuickAdd, [{
    key: "handleAddToCart",
    value: function handleAddToCart() {
      var selectedVariant = this.querySelector('input[type="radio"]:checked');
      if (selectedVariant) {
        var variantId = selectedVariant.dataset.variantid;
        this.addToCart(variantId);
      } else {
        var _this$querySelector;
        var _variantId = (_this$querySelector = this.querySelector('a')) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.dataset.variantid;
        this.addToCart(_variantId);
      }
    }
    // Mehod to handle adding product to cart and refreshing cart
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return fetch(this.addProductUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: [{
                    id: variantId,
                    quantity: 1
                  }]
                })
              });
            case 1:
              response = _context.v;
              if (response.ok) {
                document.dispatchEvent(new CustomEvent('theme:open-cart-drawer'));
                document.dispatchEvent(new CustomEvent('theme:cartchanged'));
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function addToCart(_x) {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Quiz.ts":
/*!**********************************************!*\
  !*** ./resources/scripts/components/Quiz.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Quiz)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Quiz = /*#__PURE__*/function (_HTMLElement) {
  function Quiz() {
    var _this;
    _classCallCheck(this, Quiz);
    _this = _callSuper(this, Quiz);
    // Initiate an empty object to store answers
    _defineProperty(_this, "quizAnswers", {
      name: '',
      answers: {}
    });
    _defineProperty(_this, "standardSelectLimit", 1);
    _defineProperty(_this, "unwantedNameChars", /[^a-zA-Z\søæå]/g);
    _this.handleSlideChange = _this.handleSlideChange.bind(_this);
    _this.handleAnswerSelection = _this.handleAnswerSelection.bind(_this);
    _this.handleAnswerSubmission = _this.handleAnswerSubmission.bind(_this);
    _this.handleNameInput = _this.handleNameInput.bind(_this);
    _this.handleEmailInput = _this.handleEmailInput.bind(_this);
    _this.handleNewsletterFormSubmit = _this.handleNewsletterFormSubmit.bind(_this);
    _this.handleQuizEnd = _this.handleQuizEnd.bind(_this);
    _this.filterQuizResults = _this.filterQuizResults.bind(_this);
    _this.fetchDiscount = _this.fetchDiscount.bind(_this);
    _this.handleAddToCart = _this.handleAddToCart.bind(_this);
    _this.checkCartForQuizProduct = _this.checkCartForQuizProduct.bind(_this);
    _this.addTagsToCustomer = _this.addTagsToCustomer.bind(_this);
    return _this;
  }
  _inherits(Quiz, _HTMLElement);
  return _createClass(Quiz, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      if (localStorage.getItem('quiz-completed')) {
        var withNewsLetter = true;
        this.handleQuizEnd(withNewsLetter);
        localStorage.removeItem('quiz-completed');
      }
      // Handle name input (First slide)
      var nameInput = this.querySelector('input[type="name"]');
      nameInput.addEventListener('input', function (event) {
        _this2.handleNameInput(event);
      });
      // Handle email input (Last slide)
      var emailInput = this.querySelector('input[type="email"]');
      emailInput.addEventListener('input', function (event) {
        _this2.handleEmailInput(event);
      });
      // Handle click on answer buttons - Not sumbitting the answer, this simply makes the continue button enabled
      var answerBtns = Array.from(this.querySelectorAll('.quiz-btn'));
      answerBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          _this2.handleAnswerSelection(btn);
        });
      });
      // Handle slide change for the slide buttons
      var slideBtns = Array.from(this.querySelectorAll('button[data-slideindex]'));
      slideBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          if (btn.dataset.emailsubmit === 'true') {
            var emailSubmitBtn = _this2.querySelector('#newsletter-submit');
            var _newsletterForm = _this2.querySelector('form[action="/contact#contact_form"]') || _this2.querySelector('form[action="/en/contact#contact_form"]');
            if (emailSubmitBtn.getAttribute('aria-disabled') === 'false') {
              event.stopPropagation();
              event.preventDefault();
              event.stopImmediatePropagation();
              // store this.quizAnswers in a object
              localStorage.setItem('quiz-answers-object', JSON.stringify(_this2.quizAnswers.answers));
              _this2.handleNewsletterFormSubmit(_newsletterForm);
            } else {
              var currentSlide = btn.closest('.quiz-slide');
              _this2.handleAnswerSubmission(currentSlide);
              var slideIndex = parseInt(btn.dataset.slideindex, 10);
              _this2.handleSlideChange(slideIndex);
            }
          } else {
            if (btn.dataset.direction === 'next') {
              var _currentSlide = btn.closest('.quiz-slide');
              _this2.handleAnswerSubmission(_currentSlide);
            }
            var _slideIndex = parseInt(btn.dataset.slideindex, 10);
            _this2.handleSlideChange(_slideIndex);
          }
        });
      });
      var newsletterForm = this.querySelector('form[action="/contact#contact_form"]') || this.querySelector('form[action="/en/contact#contact_form"]');
      newsletterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        localStorage.setItem('quiz-answers-object', JSON.stringify(_this2.quizAnswers.answers));
        _this2.handleNewsletterFormSubmit(newsletterForm);
      });
    }
  }, {
    key: "handleSlideChange",
    value: function handleSlideChange(slideIndex) {
      var slides = Array.from(this.querySelectorAll('.quiz-slide'));
      // Update the aria-hidden attribute for each slide
      // Shopify uses 1-based index for indexs, so we need to add 1 to the index
      slides.forEach(function (slide, index) {
        var newIndex = index + 1;
        slide.setAttribute('aria-hidden', newIndex === slideIndex ? 'false' : 'true');
      });
      var lastSlideIndex = slides.length;
      if (slideIndex > lastSlideIndex) {
        var withNewsLetter = false;
        this.handleQuizEnd(withNewsLetter);
      }
    }
  }, {
    key: "handleAnswerSelection",
    value: function handleAnswerSelection(btn) {
      var currentSlide = btn.closest('.quiz-slide');
      var answerBtns = Array.from(currentSlide.querySelectorAll('.quiz-btn'));
      var selectLimit = this.standardSelectLimit;
      // If the current slide has a select limit, get the limit
      if (currentSlide.dataset.selectlimit) {
        selectLimit = parseInt(currentSlide.dataset.selectlimit, 10);
      }
      var selectedCount = 0;
      // Count the number of buttons that are already selected
      answerBtns.forEach(function (button) {
        if (button.getAttribute('aria-selected') === 'true') {
          selectedCount += 1;
        }
      });
      // If there is a selectlimit greater than one, allow for multi select and deselect
      if (selectLimit > 1) {
        if (btn.getAttribute('aria-selected') === 'true') {
          btn.setAttribute('aria-selected', 'false');
          selectedCount -= 1;
        } else if (selectedCount < selectLimit) {
          btn.setAttribute('aria-selected', 'true');
          selectedCount += 1;
        }
      } else {
        // If there isn't a select limit, only allow for single select. On single select, deselect all other buttons
        selectedCount = 1;
        answerBtns.forEach(function (button) {
          button.setAttribute('aria-selected', button === btn ? 'true' : 'false');
        });
      }
      var currentSlideIndex = parseInt(currentSlide.dataset.slideindex, 10);
      var continueBtn = currentSlide.querySelector("button[data-slideindex=\"".concat(currentSlideIndex + 1, "\"]"));
      continueBtn.setAttribute('aria-disabled', selectedCount > 0 ? 'false' : 'true');
    }
  }, {
    key: "handleAnswerSubmission",
    value: function handleAnswerSubmission(currentSlide) {
      // if the current slide has a name input, store the value
      var nameInput = currentSlide.querySelector('input[type="name"]');
      if (nameInput) {
        this.quizAnswers.name = nameInput.value;
      }
      // if the current slide is a slide with radio buttons, store the selected value
      var selectedAnswers = Array.from(currentSlide.querySelectorAll('.quiz-btn[aria-selected="true"]'));
      if (selectedAnswers.length > 0) {
        this.quizAnswers.answers[currentSlide.dataset.question] = _toConsumableArray(selectedAnswers.map(function (btn) {
          return btn.value;
        }));
      }
    }
  }, {
    key: "handleNameInput",
    value: function handleNameInput(event) {
      var nameInput = event.target;
      var name = nameInput.value;
      // unless name contains unwanted characters, enable the next button
      if (name.match(this.unwantedNameChars)) {
        nameInput.value = name.replace(this.unwantedNameChars, '');
      }
      var currentSlide = nameInput.closest('.quiz-slide');
      var nextBtn = currentSlide.querySelector('button[data-slideindex]');
      nextBtn.setAttribute('aria-disabled', name && name.length > 0 ? 'false' : 'true');
    }
  }, {
    key: "handleEmailInput",
    value: function handleEmailInput(event) {
      var emailInput = event.target;
      var email = emailInput.value;
      var submitBtn = this.querySelector('#newsletter-submit');
      var currentSlide = emailInput.closest('.quiz-slide');
      var nextBtn = currentSlide.querySelector('button[data-emailsubmit]');
      if (email && email.includes('@') && email.includes('.')) {
        submitBtn.setAttribute('aria-disabled', 'false');
        nextBtn.setAttribute('aria-disabled', 'false');
      } else {
        submitBtn.setAttribute('aria-disabled', 'true');
        nextBtn.setAttribute('aria-disabled', 'true');
      }
    }
  }, {
    key: "handleNewsletterFormSubmit",
    value: function handleNewsletterFormSubmit(form) {
      var _this3 = this;
      // Get the customer name from the quiz answers
      var customerName = this.quizAnswers.name;
      // add the first and last name to the form with a input type text with name="customer[first_name]" and name="customer[last_name]
      var customerNameInput = document.createElement('input');
      customerNameInput.type = 'hidden';
      customerNameInput.name = 'contact[first_name]';
      customerNameInput.value = customerName;
      form.appendChild(customerNameInput);
      // Now add the quiz answers to the forms input contact[tags] with the value of the quiz answers separated by a comma
      var tagsInput = form.querySelector('input[name="contact[tags]"]');
      // if the value of a key is an array, create two values for the key like "Key1:value1,Key1:value2". This is in case of multiselect answers
      /* eslint-disable */
      var _loop = function _loop(key) {
        var value = _this3.quizAnswers.answers[key];
        if (Array.isArray(value)) {
          value.forEach(function (val) {
            tagsInput.value += "".concat(key, ":").concat(val, ",");
          });
        } else {
          tagsInput.value += "".concat(key, ":").concat(value, ",");
        }
      };
      for (var key in this.quizAnswers.answers) {
        _loop(key);
      }
      tagsInput.value += 'quiz-completed';
      /* eslint-disable */
      // Remove the trailing comma
      if (tagsInput.value.endsWith(',')) {
        tagsInput.value = tagsInput.value.slice(0, -1);
      }
      var emailInput = form.querySelector('input[name="contact[email]"]');
      //this.addTagsToCustomer(tagsInput.value, emailInput.value);
      this.captureKlaviyoEventDetails(tagsInput.value, emailInput.value);
      // Submit the form
      localStorage.setItem('quiz-completed', 'true');
      setTimeout(function () {
        form.submit();
      }, 1000);
    }
    // this event is fired after the form is submitted (Actually happens after the form is submitted and the page is reloaded)
  }, {
    key: "handleQuizEnd",
    value: function handleQuizEnd(place) {
      var quizContainer = this.querySelector('.quiz-container');
      var quizResultsContainer = this.querySelector('.quiz-container.results-container');
      quizContainer.setAttribute('aria-hidden', 'true');
      quizResultsContainer.setAttribute('aria-hidden', 'false');
      // do stuff with the quiz results
      this.filterQuizResults(place);
    }
  }, {
    key: "filterQuizResults",
    value: function () {
      var _filterQuizResults = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(place) {
        var _this4 = this;
        var answers, allProducts, addToCartBtns, spinner, quizResults, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.p = 0;
              // turn all keys of the answers into lowercase

              if (localStorage.getItem('quiz-answers-object')) {
                answers = JSON.parse(localStorage.getItem('quiz-answers-object'));
              } else {
                answers = this.quizAnswers.answers;
              }
              answers = Object.keys(answers).reduce(function (acc, key) {
                acc[key.toLowerCase()] = answers[key];
                return acc;
              }, {});
              allProducts = Array.from(this.querySelectorAll('.quiz-product')); // filter the products based on the answers
              allProducts.forEach(function (product) {
                var isMatch = false;
                // The key of the answer is the same as the dataset key of the product
                // Check if the answer is in the dataset of the product
                var _loop2 = function _loop2(key) {
                  if (product.dataset[key] !== undefined) {
                    if (answers[key].length > 1) {
                      var values = answers[key];
                      values.forEach(function (value) {
                        if (product.dataset[key].includes(value)) {
                          isMatch = true;
                        }
                      });
                    } else {
                      if (product.dataset[key].includes(answers[key])) {
                        isMatch = true;
                      }
                    }
                  }
                };
                for (var key in answers) {
                  _loop2(key);
                }
                if (isMatch) {
                  product.setAttribute('aria-hidden', 'false');
                  setTimeout(function () {
                    product.style.opacity = '1';
                  }, 500);
                }
              });
              if (place == true) {
                console.log('Got to place');
                localStorage.removeItem('quiz-answers-object');
                addToCartBtns = Array.from(this.querySelectorAll('.quick-action-button'));
                addToCartBtns.forEach(function (btn) {
                  btn.addEventListener('click', /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
                      var variantId, cartContainsQuizProduct;
                      return _regenerator().w(function (_context) {
                        while (1) switch (_context.n) {
                          case 0:
                            event.preventDefault();
                            event.stopPropagation();
                            variantId = btn.dataset['variantId'];
                            _context.n = 1;
                            return _this4.checkCartForQuizProduct();
                          case 1:
                            cartContainsQuizProduct = _context.v;
                            console.log(cartContainsQuizProduct, 'cartContainsQuizProduct');
                            if (!cartContainsQuizProduct) {
                              _this4.handleAddToCart(variantId);
                            } else {
                              alert('Du har allerede tilføjet et produkt fra quizzen til kurven');
                            }
                          case 2:
                            return _context.a(2);
                        }
                      }, _callee);
                    }));
                    return function (_x2) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                });
                setTimeout(function () {
                  var recommendedProduct = _this4.querySelector('.quiz-product[style="opacity: 1;"]');
                  var recommendedProductObject = {
                    id: recommendedProduct.dataset.id,
                    title: recommendedProduct.dataset.title,
                    image: recommendedProduct.dataset.image,
                    price: recommendedProduct.dataset.price,
                    handle: recommendedProduct.dataset.handle,
                    url: recommendedProduct.dataset.url,
                    tags: recommendedProduct.dataset.tags
                  };
                  _this4.sendKlaviyoEvent(recommendedProductObject);
                }, 1500);
              }
              // fetch discount
              this.fetchDiscount();
              _context2.n = 2;
              break;
            case 1:
              _context2.p = 1;
              _t = _context2.v;
              throw new Error(_t);
            case 2:
              _context2.p = 2;
              spinner = this.querySelector('.quiz-loading-spinner');
              spinner.style.display = 'none';
              quizResults = this.querySelector('.quiz-results-products');
              quizResults.setAttribute('aria-hidden', 'false');
              return _context2.f(2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 1, 2, 3]]);
      }));
      function filterQuizResults(_x) {
        return _filterQuizResults.apply(this, arguments);
      }
      return filterQuizResults;
    }()
  }, {
    key: "fetchDiscount",
    value: function () {
      var _fetchDiscount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var response, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return fetch('/discount/hartest');
            case 1:
              response = _context3.v;
              console.log(response);
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              throw new Error(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      function fetchDiscount() {
        return _fetchDiscount.apply(this, arguments);
      }
      return fetchDiscount;
    }()
  }, {
    key: "handleAddToCart",
    value: function () {
      var _handleAddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(variantId) {
        var response, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                  properties: {
                    _quiz: 'true'
                  }
                })
              });
            case 1:
              response = _context4.v;
              if (response.ok) {
                document.dispatchEvent(new CustomEvent('theme:open-cart-drawer'));
                document.dispatchEvent(new CustomEvent('theme:cartchanged'));
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              throw new Error(_t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }));
      function handleAddToCart(_x3) {
        return _handleAddToCart.apply(this, arguments);
      }
      return handleAddToCart;
    }()
  }, {
    key: "checkCartForQuizProduct",
    value: function () {
      var _checkCartForQuizProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var response, cart, quizProduct, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return fetch('/cart.js');
            case 1:
              response = _context5.v;
              if (!response.ok) {
                _context5.n = 4;
                break;
              }
              _context5.n = 2;
              return response.json();
            case 2:
              cart = _context5.v;
              quizProduct = cart.items.find(function (item) {
                return item.properties._quiz === 'true';
              });
              if (!quizProduct) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2, true);
            case 3:
              return _context5.a(2, false);
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t4 = _context5.v;
              throw new Error(_t4);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 5]]);
      }));
      function checkCartForQuizProduct() {
        return _checkCartForQuizProduct.apply(this, arguments);
      }
      return checkCartForQuizProduct;
    }()
  }, {
    key: "addTagsToCustomer",
    value: function () {
      var _addTagsToCustomer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(tags, email) {
        var body, response, data, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.p = 0;
              body = {
                tags: tags,
                email: email
              };
              _context6.n = 1;
              return fetch('https://server-for-parkstyling.vercel.app/api/addcustomertags', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              });
            case 1:
              response = _context6.v;
              if (!response.ok) {
                _context6.n = 3;
                break;
              }
              _context6.n = 2;
              return response.json();
            case 2:
              data = _context6.v;
              console.log(data);
            case 3:
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t5 = _context6.v;
              throw new Error(_t5);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 4]]);
      }));
      function addTagsToCustomer(_x4, _x5) {
        return _addTagsToCustomer.apply(this, arguments);
      }
      return addTagsToCustomer;
    }()
  }, {
    key: "captureKlaviyoEventDetails",
    value: function captureKlaviyoEventDetails(tags, email) {
      var quizProps = tags.split(',').reduce(function (acc, tag) {
        var _tag$split = tag.split(':'),
          _tag$split2 = _slicedToArray(_tag$split, 2),
          key = _tag$split2[0],
          value = _tag$split2[1];
        if (key === 'quiz-completed') {
          return acc;
        }
        acc[key] = value;
        return acc;
      }, {});
      var details = {
        email: email,
        quizProps: quizProps
      };
      sessionStorage.setItem('klaviyo-event-details', JSON.stringify(details));
    }
  }, {
    key: "sendKlaviyoEvent",
    value: function () {
      var _sendKlaviyoEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(productObject) {
        var details, attributeProps, body, response, data, _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.p = 0;
              details = JSON.parse(sessionStorage.getItem('klaviyo-event-details'));
              attributeProps = _objectSpread(_objectSpread({}, details.quizProps), {}, {
                Product: _objectSpread({}, productObject)
              });
              body = {
                data: {
                  type: 'event',
                  attributes: {
                    properties: attributeProps,
                    metric: {
                      data: {
                        type: 'metric',
                        attributes: {
                          name: 'hårtest completed'
                        }
                      }
                    },
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: details.email,
                          properties: details.quizProps
                        }
                      }
                    }
                  }
                }
              };
              console.log(body);
              _context7.n = 1;
              return fetch('https://server-for-parkstyling.vercel.app/api/klaviyoevent', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              });
            case 1:
              response = _context7.v;
              if (response.ok) {
                _context7.n = 2;
                break;
              }
              throw new Error('Error sending Klaviyo event');
            case 2:
              sessionStorage.removeItem('klaviyo-event-details');
              _context7.n = 3;
              return response.json();
            case 3:
              data = _context7.v;
              console.log(data);
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t6 = _context7.v;
              throw new Error(_t6);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, null, [[0, 4]]);
      }));
      function sendKlaviyoEvent(_x6) {
        return _sendKlaviyoEvent.apply(this, arguments);
      }
      return sendKlaviyoEvent;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/StoreLocator/GoogleMaps.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/StoreLocator/GoogleMaps.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GoogleMaps)
/* harmony export */ });
/* harmony import */ var _Places__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Places */ "./resources/scripts/components/StoreLocator/Places.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var GoogleMaps = /*#__PURE__*/function () {
  function GoogleMaps() {
    _classCallCheck(this, GoogleMaps);
    _defineProperty(this, "map", void 0);
    this.initGoogleMapsScript = this.initGoogleMapsScript.bind(this);
    this.initMap = this.initMap.bind(this);
    this.addMarkers = this.addMarkers.bind(this);
    this.handleMissingParams = this.handleMissingParams.bind(this);
    this.panPinIntoView = this.panPinIntoView.bind(this);
  }
  // Method to initialize the google maps script
  /* eslint-disable */
  return _createClass(GoogleMaps, [{
    key: "initGoogleMapsScript",
    value: function initGoogleMapsScript(apiKey, version, language, region) {
      var script = document.createElement('script');
      script.innerHTML = "\n    (g => {\n      var h, a, k, p = \"The Google Maps JavaScript API\",\n          c = \"google\", l = \"importLibrary\", q = \"__ib__\",\n          m = document, b = window;\n      b = b[c] || (b[c] = {});\n      var d = b.maps || (b.maps = {}),\n          r = new Set, e = new URLSearchParams,\n          u = () => h || (h = new Promise(async (f, n) => {\n            await (a = m.createElement(\"script\"));\n            e.set(\"libraries\", [...r] + \"\");\n            for (k in g) e.set(k.replace(/[A-Z]/g, t => \"_\" + t[0].toLowerCase()), g[k]);\n            e.set(\"callback\", c + \".maps.\" + q);\n            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;\n            d[q] = f;\n            a.onerror = () => h = n(Error(p + \" could not load.\"));\n            a.nonce = m.querySelector(\"script[nonce]\")?.nonce || \"\";\n            m.head.append(a);\n          }));\n      d[l] ? console.warn(p + \" only loads once. Ignoring:\", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));\n    })({\n      key: \"".concat(apiKey, "\",\n      v: \"").concat(version, "\",\n      language: \"").concat(language, "\",\n      region: \"").concat(region, "\",\n    });\n    ");
      document.body.appendChild(script);
    }
    /* eslint-disable */
    // Method to initialize the map
  }, {
    key: "initMap",
    value: (function () {
      var _initMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(apiKey, version, language, region) {
        var _this = this;
        var missingParams, _yield$google$maps$im, Map, PlacesApi;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              missingParams = this.handleMissingParams(apiKey, version, language, region);
              if (!missingParams) {
                _context.n = 1;
                break;
              }
              console.error(missingParams);
              return _context.a(2);
            case 1:
              this.initGoogleMapsScript(apiKey, version, language, region);
              _context.n = 2;
              return google.maps.importLibrary('maps');
            case 2:
              _yield$google$maps$im = _context.v;
              Map = _yield$google$maps$im.Map;
              this.map = new Map(document.getElementById('map'), {
                center: {
                  lat: 55.56682,
                  lng: 9.75452
                },
                zoom: 8,
                mapId: 'ec10f55bcbe31d2b'
              });
              this.addMarkers(this.map);
              document.addEventListener('Edition:PanPinIntoView', function (event) {
                _this.panPinIntoView(event, _this.map);
              });
              PlacesApi = new _Places__WEBPACK_IMPORTED_MODULE_0__["default"]();
              _context.n = 3;
              return PlacesApi.init();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initMap(_x, _x2, _x3, _x4) {
        return _initMap.apply(this, arguments);
      }
      return initMap;
    }() // Method to add markers to the map
    )
  }, {
    key: "addMarkers",
    value: function () {
      var _addMarkers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(map) {
        var _this2 = this;
        var _yield$google$maps$im2, InfoWindow, _yield$google$maps$im3, AdvancedMarkerElement, PinElement, markers, infoWindow, storeLocator;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return google.maps.importLibrary('maps');
            case 1:
              _yield$google$maps$im2 = _context2.v;
              InfoWindow = _yield$google$maps$im2.InfoWindow;
              _context2.n = 2;
              return google.maps.importLibrary('marker');
            case 2:
              _yield$google$maps$im3 = _context2.v;
              AdvancedMarkerElement = _yield$google$maps$im3.AdvancedMarkerElement;
              PinElement = _yield$google$maps$im3.PinElement;
              // Get the markers from the window object (Our stores)
              markers = window.advancedMarkerData; // Create an info window to share between markers.
              infoWindow = new InfoWindow();
              storeLocator = document.querySelector('store-locator');
              console.log;
              // Loop through the markers and add them to the map. We use the PinElement to create a custom marker
              markers.forEach(function (marker) {
                var glyphImg;
                if (storeLocator.dataset.pinglyphimg) {
                  glyphImg = document.createElement('img');
                  glyphImg.style.width = '22px';
                  glyphImg.style.height = '22px';
                  glyphImg.style.marginTop = '-60px';
                  glyphImg.src = storeLocator.dataset.pinglyphimg;
                } else {
                  glyphImg === null;
                }
                var pin = new PinElement({
                  scale: 9,
                  background: storeLocator.dataset.pinbackground,
                  borderColor: storeLocator.dataset.pinbordercolor,
                  glyphColor: storeLocator.dataset.pinglyphcolor,
                  glyph: glyphImg
                });
                var newMarker = new AdvancedMarkerElement({
                  map: _this2.map,
                  position: marker.position,
                  title: marker.title,
                  content: pin.element,
                  gmpClickable: true
                });
                newMarker.addListener('mouseover', function () {});
                newMarker.addListener('click', function (_ref) {
                  var domEvent = _ref.domEvent,
                    latLng = _ref.latLng;
                  // fire a custom event. We listen for this event in the store-locator component
                  document.dispatchEvent(new CustomEvent('Edition:findStoreInList', {
                    detail: {
                      position: newMarker.position
                    }
                  }));
                  console.log(newMarker.position);
                  var target = domEvent.target;
                  infoWindow.close();
                  /* Replace htmlEle innerHTML with the html you want in the content
                  const htmlEle = document.createElement('div');
                  htmlEle.innerHTML = `
                  `;
                           infoWindow.setContent(htmlEle);
                  */
                  infoWindow.open(newMarker.map, newMarker);
                });
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function addMarkers(_x5) {
        return _addMarkers.apply(this, arguments);
      }
      return addMarkers;
    }() // Method to pan the map to a marker. This method is called when a search is performed. Fired when Edition:PanPinIntoView is dispatched
  }, {
    key: "panPinIntoView",
    value: function panPinIntoView(event, map) {
      // turn lat and lng into numbers
      var markerPosition = {
        lat: Number(event.detail.position.lat),
        lng: Number(event.detail.position.lng)
      };
      map.panTo(markerPosition);
      map.setZoom(10);
    }
    // Method to handle missing params
  }, {
    key: "handleMissingParams",
    value: function handleMissingParams(apiKey, version, language, region) {
      if (!apiKey) {
        return 'Edition - Missing Google Maps API Key Param';
      }
      if (!version) {
        return 'Edition - Missing Google Maps Version Param';
      }
      if (!language) {
        return 'Edition - Missing Google Maps Language Param';
      }
      if (!region) {
        return 'Edition - Missing Google Maps Region Param';
      }
      return null;
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/StoreLocator/Places.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/StoreLocator/Places.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Places)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
var Places = /*#__PURE__*/function () {
  function Places() {
    _classCallCheck(this, Places);
    _defineProperty(this, "testString", 'test');
    this.init = this.init.bind(this);
    this.initPlaceAutoCompletion = this.initPlaceAutoCompletion.bind(this);
  }
  return _createClass(Places, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$google$maps$im, Place, AutocompleteSessionToken, AutocompleteSuggestion;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return google.maps.importLibrary('places');
            case 1:
              _yield$google$maps$im = _context.v;
              Place = _yield$google$maps$im.Place;
              AutocompleteSessionToken = _yield$google$maps$im.AutocompleteSessionToken;
              AutocompleteSuggestion = _yield$google$maps$im.AutocompleteSuggestion;
              this.initPlaceAutoCompletion(Place, AutocompleteSessionToken, AutocompleteSuggestion);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initPlaceAutoCompletion",
    value: function initPlaceAutoCompletion(Place, AutocompleteSessionToken, AutocompleteSuggestion) {
      var _this = this;
      var placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({
        componentRestrictions: {
          country: ['dk']
        }
      });
      var searchPlaceHolder = document.querySelector('.store-locator-search');
      searchPlaceHolder.appendChild(placeAutocomplete);
      // @ts-ignore
      placeAutocomplete.addEventListener('gmp-select', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref) {
          var placePrediction;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                placePrediction = _ref.placePrediction;
                _this.handlePlaceSelection(placePrediction);
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handlePlaceSelection",
    value: function () {
      var _handlePlaceSelection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(placePrediction) {
        var place, selectedPlaceData, selectedPlace, selectedPlaceLocation, coordinates, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.p = 0;
              // Ensure you are using the correct method for fetching fields
              place = placePrediction.toPlace();
              console.log('place', place);
              _context3.n = 1;
              return place.fetchFields({
                fields: ['location']
              });
            case 1:
              selectedPlaceData = _context3.v;
              selectedPlace = selectedPlaceData === null || selectedPlaceData === void 0 ? void 0 : selectedPlaceData.place;
              selectedPlaceLocation = Object.values(selectedPlace).find(function (placeData) {
                return placeData === null || placeData === void 0 ? void 0 : placeData.location;
              });
              if (selectedPlaceLocation) {
                coordinates = {
                  lat: selectedPlaceLocation.location.lat,
                  lng: selectedPlaceLocation.location.lng
                };
                document.dispatchEvent(new CustomEvent('Edition:ShowMap'));
                document.dispatchEvent(new CustomEvent('Edition:FindNearbyStores', {
                  detail: {
                    position: coordinates
                  }
                }));
                document.dispatchEvent(new CustomEvent('Edition:PanPinIntoView', {
                  detail: {
                    position: coordinates
                  }
                }));
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              console.error('Error handling place selection:', _t);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      function handlePlaceSelection(_x2) {
        return _handlePlaceSelection.apply(this, arguments);
      }
      return handlePlaceSelection;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/StoreLocator/StoreLocator.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/StoreLocator/StoreLocator.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ StoreLocator)
/* harmony export */ });
/* harmony import */ var _GoogleMaps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GoogleMaps */ "./resources/scripts/components/StoreLocator/GoogleMaps.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */

var StoreLocator = /*#__PURE__*/function (_HTMLElement) {
  function StoreLocator() {
    var _this;
    _classCallCheck(this, StoreLocator);
    _this = _callSuper(this, StoreLocator);
    _defineProperty(_this, "apiKey", 'AIzaSyCgE88ARRwkzEOBP3D_WuNrkJ-gzdEk6zc');
    _defineProperty(_this, "version", _this.dataset.version);
    _defineProperty(_this, "language", _this.dataset.language);
    _defineProperty(_this, "region", _this.dataset.region);
    _defineProperty(_this, "loader", _this.querySelector('.store-locator__loader'));
    // Declare the debouncedSearch property
    _defineProperty(_this, "debouncedSearch", void 0);
    _this.handleMapAndList = _this.handleMapAndList.bind(_this);
    _this.handleRegionSelection = _this.handleRegionSelection.bind(_this);
    _this.setAriaAttribute = _this.setAriaAttribute.bind(_this);
    _this.getVisitorLocation = _this.getVisitorLocation.bind(_this);
    _this.handleShowNearbyStores = _this.handleShowNearbyStores.bind(_this);
    _this.findStoreFromMarker = _this.findStoreFromMarker.bind(_this);
    return _this;
  }
  _inherits(StoreLocator, _HTMLElement);
  return _createClass(StoreLocator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initGoogleMaps();
      this.getVisitorLocation();
      // When clicking on one of the action buttons. Set the aria-selected attribute to true and handle the map and list
      var actionBtns = Array.from(this.querySelectorAll('.store-locator-action-btn'));
      actionBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleMapAndList(btn);
        });
      });
      // When clicking on one of the regions. Set the aria-selected attribute to true and handle the region selection
      var listRegionsBtns = Array.from(this.querySelectorAll('.store-locator-region'));
      listRegionsBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleRegionSelection(btn);
        });
      });
      /*  const searchEle = this.querySelector('input[type="search"]') as HTMLInputElement;
      console.log(searchEle, 'searchEle');
      searchEle.addEventListener('input', () => {
        const searchTerm = searchEle.value;
        this.debouncedSearch(searchTerm);
      }); */
      document.addEventListener('Edition:findStoreInList', function (event) {
        _this2.findStoreFromMarker(event);
      });
      document.addEventListener('Edition:FindNearbyStores', function (event) {
        _this2.handleShowNearbyStores(event.detail.position.lat, event.detail.position.lng);
      });
      document.addEventListener('Edition:ShowMap', function () {
        _this2.handleMapAndList(_this2.querySelector('.store-locator-action-btn[data-action="map"]'));
        var storesWrapperInMapView = document.querySelector('.store-locator__map-stores');
        storesWrapperInMapView.setAttribute('aria-hidden', 'false');
      });
    }
  }, {
    key: "initGoogleMaps",
    value: function initGoogleMaps() {
      var googleMaps = new _GoogleMaps__WEBPACK_IMPORTED_MODULE_0__["default"]();
      googleMaps.initMap(this.apiKey, this.version, this.language, this.region);
    }
  }, {
    key: "getVisitorLocation",
    value: function getVisitorLocation() {
      var _this3 = this;
      var successCallback = function successCallback(position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        if (latitude && longitude) {
          _this3.sortStoresByDistanceFromPosition(latitude, longitude);
        }
      };
      var errorCallback = function errorCallback() {
        _this3.sortStoresByDataAttribute();
        if (_this3.loader) {
          _this3.loader.classList.add('!tw-hidden');
        }
      };
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
      } else {
        this.sortStoresByDataAttribute();
      }
    }
  }, {
    key: "sortStoresByDataAttribute",
    value: function sortStoresByDataAttribute() {
      var storeLists = Array.from(this.querySelectorAll('.store-list-wrapper'));
      storeLists.forEach(function (storeList) {
        var allStores = Array.from(storeList.querySelectorAll('.store'));
        var sortedStores = [];
        // Sort the stores by the data-order attribute. If the
        sortedStores = allStores.sort(function (a, b) {
          return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
        });
        // Append the sorted stores to the store wrapper
        sortedStores.forEach(function (store) {
          storeList.appendChild(store);
          store.classList.remove('!tw-hidden');
        });
        console.log(storeList, 'storeList');
      });
    }
  }, {
    key: "sortStoresByDistanceFromPosition",
    value: function sortStoresByDistanceFromPosition(latitude, longitude) {
      var _this4 = this;
      var storeLists = Array.from(this.querySelectorAll('.store-list-wrapper'));
      storeLists.forEach(function (storeList) {
        var allStores = Array.from(storeList.querySelectorAll('.store'));
        var sortedStores = [];
        // The closer the distance is to 0, the closer the store is to the visitor
        sortedStores = allStores.sort(function (a, b) {
          var aDistance = _this4.calculateDistanceFromVisitor(latitude, longitude, parseFloat(a.dataset.latitude), parseFloat(a.dataset.longitude));
          var bDistance = _this4.calculateDistanceFromVisitor(latitude, longitude, parseFloat(b.dataset.latitude), parseFloat(b.dataset.longitude));
          return aDistance - bDistance;
        });
        // Append the sorted stores to the store wrapper
        sortedStores.forEach(function (store) {
          storeList.appendChild(store);
          store.classList.remove('!tw-hidden');
        });
        _this4.loader.classList.add('!tw-hidden');
      });
    }
  }, {
    key: "sortStoresByDistanceFromSelectedPosition",
    value: function sortStoresByDistanceFromSelectedPosition(sortedStores, latitude, longitude) {
      var _this5 = this;
      sortedStores.sort(function (a, b) {
        var aDistance = _this5.calculateDistanceFromVisitor(latitude, longitude, parseFloat(a.dataset.latitude), parseFloat(a.dataset.longitude));
        var bDistance = _this5.calculateDistanceFromVisitor(latitude, longitude, parseFloat(b.dataset.latitude), parseFloat(b.dataset.longitude));
        return aDistance - bDistance;
      });
      // Append the sorted stores to the store wrapper
      sortedStores.forEach(function (store) {
        store.parentElement.appendChild(store);
      });
    }
  }, {
    key: "handleShowNearbyStores",
    value: function handleShowNearbyStores(latitude, longitude) {
      var _this6 = this;
      var sortedStores = [];
      var storeLists = Array.from(this.querySelectorAll('.store-list-wrapper'));
      storeLists.forEach(function (storeList) {
        var allStores = Array.from(storeList.querySelectorAll('.store'));
        if (latitude == null || longitude == null) {
          allStores.forEach(function (store) {
            store.classList.remove('!tw-hidden');
          });
        } else {
          allStores.forEach(function (store) {
            var storeLatitude = parseFloat(store.dataset.latitude);
            var storeLongitude = parseFloat(store.dataset.longitude);
            // if the store is within a given distance, show it
            if (!_this6.isWithinDistance(latitude, longitude, storeLatitude, storeLongitude)) {
              store.classList.add('!tw-hidden');
            } else {
              store.classList.remove('!tw-hidden');
              sortedStores.push(store);
            }
          });
          _this6.sortStoresByDistanceFromSelectedPosition(sortedStores, latitude, longitude);
        }
      });
    }
  }, {
    key: "calculateDistanceFromVisitor",
    value: function calculateDistanceFromVisitor(lat1, lon1, lat2, lon2) {
      if (lat1 == null || lon1 == null) {
        return null;
      }
      // return the distance between lat1, lon1 and lat2, lon2 in numbers
      var latDiff = lat1 - lat2;
      var lonDiff = lon1 - lon2;
      return Math.sqrt(latDiff * latDiff + lonDiff * lonDiff);
    }
  }, {
    key: "isWithinDistance",
    value: function isWithinDistance(lat1, lon1, lat2, lon2) {
      // 1 lat = 110.574 km
      // 1 long = 111.320*cos(lat) km
      // 1km = 0.009043717329571 deg, 0.008983111749909 deg
      // 10km = 0.09043717329571 deg, 0.08983111749909 deg
      // 30km = 0.27231151988713 deg, 0.26949335249727 deg
      // 50km = 0.45419586647855 deg, 0.44915558749545 deg
      return Math.abs(lat1 - lat2) < 0.4541958664785 && Math.abs(lon1 - lon2) < 0.44915558749545;
    }
    // Handle the map and list selection
  }, {
    key: "handleMapAndList",
    value: function handleMapAndList(btn) {
      var actionBtns = Array.from(this.querySelectorAll('.store-locator-action-btn'));
      this.setAriaAttribute(actionBtns, btn, 'aria-selected');
      var action = btn.dataset.action;
      var mapContent = this.querySelector('.store-locator-content__type[data-action="map"]');
      var listContent = this.querySelector('.store-locator-content__type[data-action="list"]');
      if (action === 'list') {
        this.setAriaAttribute([mapContent, listContent], mapContent, 'aria-hidden');
      } else if (action === 'map') {
        this.setAriaAttribute([mapContent, listContent], listContent, 'aria-hidden');
      }
    }
    // Handle the region selection
  }, {
    key: "handleRegionSelection",
    value: function handleRegionSelection(btn) {
      this.getVisitorLocation(); // Sort the stores by distance from the visitor
      var listRegionsBtns = Array.from(this.querySelectorAll('.store-locator-region'));
      this.setAriaAttribute(listRegionsBtns, btn, 'aria-selected');
      var region = btn.dataset.regionname;
      var activeRegion = this.querySelector(".store-locator-region-wrapper[data-regionname=\"".concat(region, "\"]"));
      var regionWrappers = Array.from(this.querySelectorAll('.store-locator-region-wrapper'));
      this.setAriaAttribute(regionWrappers, activeRegion, 'aria-expanded');
    }
  }, {
    key: "findStoreFromMarker",
    value: function findStoreFromMarker(event) {
      var markerPosition = {
        lat: event.detail.position.lat,
        lng: event.detail.position.lng
      };
      // turn the marker position into a string, so we can search for it
      var markerPositionStr = "".concat(markerPosition.lat, ",").concat(markerPosition.lng);
      var allStores = Array.from(this.querySelectorAll('.store'));
      allStores.forEach(function (store) {
        store.classList.add('!tw-hidden');
        var storePosition = {
          lat: parseFloat(store.dataset.latitude),
          lng: parseFloat(store.dataset.longitude)
        };
        var storePositionStr = "".concat(storePosition.lat, ",").concat(storePosition.lng);
        if (storePositionStr === markerPositionStr) {
          store.classList.remove('!tw-hidden');
        }
      });
    }
    /* eslint-disable */
  }, {
    key: "handleDebounce",
    value: function handleDebounce(func, wait) {
      var timeout;
      return function executedFunction() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var later = function later() {
          timeout = null;
          func.apply(void 0, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    /* eslint-disable */
    /* eslint-disable */
  }, {
    key: "setAriaAttribute",
    value: function setAriaAttribute(elements, element, state) {
      elements.forEach(function (ele) {
        ele.setAttribute(state, 'false');
      });
      element.setAttribute(state, 'true');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/src/assets/app": 0,
/******/ 			"src/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkparkstyling"] = self["webpackChunkparkstyling"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;